// Staff CRM look. 'classic' = today's CRM (no attributes). Anything unknown or missing is
// treated as classic so a half-saved or old account never gets a half-styled page.
export const APPEARANCES = ['classic', 'light', 'dark', 'auto'];

export const normalizeAppearance = (value) => (APPEARANCES.includes(value) ? value : 'classic');

export function resolveTheme(appearance, prefersDark) {
  const a = normalizeAppearance(appearance);
  if (a === 'classic') return null;
  if (a === 'auto') return prefersDark ? 'dark' : 'light';
  return a;
}

// Lives on <html>, not the layout div, so modals and anything outside the layout tree follow.
export function applyThemeAttributes(el, theme) {
  if (!theme) {
    el.removeAttribute('data-look');
    el.removeAttribute('data-theme');
    return;
  }
  el.setAttribute('data-look', 'v2');
  el.setAttribute('data-theme', theme);
}
